import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Link } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';
import { ConnectionBridge } from '../connectionBridge';

// Flag-off rendering — preserved unchanged so networks without the
// relationship_strength feature see exactly today's intro-paths view.
export const LegacyCard = ({ network, nodesForRender, onContactClick }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: '3fr 1fr 3fr 1fr 3fr',
      borderBottom: '1px solid',
      borderColor: 'border.subtle',
      overflow: 'hidden',
      alignItems: 'flex-start',
      p: '24px 0',
      gap: '8px',
    }}
  >
    {nodesForRender.map((node, index) => (
      <React.Fragment key={node.key}>
        {(node.kind === 'user' || node.kind === 'contact') && (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '40px 1fr',
              gap: '8px',
              ...(nodesForRender.length === 2 && index === 1 && { gridColumn: '5' }),
            }}
          >
            <div style={{ width: '40px', height: '40px' }}>
              {node.kind === 'contact' ? (
                <Link
                  href={`/networks/${network?.slug}/contacts/${node.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => onContactClick(node.id)}
                >
                  <ProfilePicture name={node.avatarName} imageUrl={node.avatarUrl} />
                </Link>
              ) : (
                <ProfilePicture name={node.avatarName} imageUrl={node.avatarUrl} />
              )}
            </div>
            <Box>
              {node.kind === 'contact' ? (
                <Link
                  href={`/networks/${network?.slug}/contacts/${node.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  fontWeight="500"
                  color="text.dark"
                  fontSize="12px"
                  sx={{
                    display: 'block',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                  onClick={() => onContactClick(node.id)}
                >
                  {node.labelName}
                </Link>
              ) : (
                <Text
                  fontWeight="500"
                  color="text.dark"
                  fontSize="12px"
                  sx={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                  {node.labelName}
                </Text>
              )}
              <Text fontSize="12px" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {node.currentJobTitle}
              </Text>
              <Text
                mt="4px"
                width="fit-content"
                fontSize="10px"
                fontWeight="500"
                color={node.kind === 'user' ? 'purple.500' : 'text.main'}
                backgroundColor={node.kind === 'user' ? 'purple.100' : 'neutral.50'}
                px="8px"
                py="2px"
                sx={{ textTransform: 'uppercase', borderRadius: '4px' }}
              >
                {node.kind === 'user' ? 'Team' : 'Contact'}
              </Text>
            </Box>
          </Box>
        )}
        {node.kind === 'signal' && (
          <Box sx={{ alignSelf: 'center', ...(nodesForRender.length === 3 && { gridColumn: '2 / 5' }) }}>
            <ConnectionBridge signal={node} />
          </Box>
        )}
      </React.Fragment>
    ))}
  </Box>
);

LegacyCard.propTypes = {
  network: PropTypes.object.isRequired,
  nodesForRender: PropTypes.arrayOf(PropTypes.object).isRequired,
  onContactClick: PropTypes.func.isRequired,
};
